import { ReactComponent as InfoOutlined } from '../../../../assets/icons/info-outlined.svg';

export { InfoOutlined };
